import React from "react";
import StepProgressBar from "../ui/StepProgressBar";

const OnboardingLayout = ({ steps, currentStep, children }) => (
  <div className="min-h-screen bg-pageBg">
    <header className="bg-cardBg border-b border-cardBorder px-6 py-4">
      <img src="/borderlessLogo.svg" alt="Borderless" className="h-8" />
    </header>
    <div className="max-w-[640px] mx-auto px-4 py-10">
      {steps && steps.length > 0 && (
        <div className="mb-8">
          <StepProgressBar steps={steps} currentStep={currentStep} />
        </div>
      )}
      {children}
    </div>
  </div>
);

export default OnboardingLayout;
